import axios from "axios";
import { useLangStore } from "@/stores/langStore";

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const langStore = useLangStore();
  config.headers["Accept-Language"] = langStore.current;

  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;
